import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  width?: 'default' | 'narrow' | 'wide';
  className?: string;
}

const widthClasses = {
  default: 'max-w-[var(--content-max)]',
  narrow: 'max-w-[var(--content-narrow)]',
  wide: 'max-w-[var(--content-wide)]',
} as const;

export function PageShell({ children, width = 'default', className = '' }: PageShellProps) {
  return (
    <div className={`mx-auto w-full px-4 sm:px-6 ${widthClasses[width]} ${width} ${className}`}>
      {children}
    </div>
  );
}
